import AbstractAuthorizationProvider from './AbstractAuthorizationProvider';

export const LoginEvent = Object.freeze({
	BADGE: 'badge',
	LOGIN: 'login',
	LOGOUT: 'logout',
	FORGET: 'forget'
});

export const LoginState = Object.freeze({
	FAILED: 'fail',
	FORGOTTEN: 'forget',
	SIGNED_IN: 'login',
	SIGNED_OUT: 'logout'
});

export default class SznLoginAuthorizationProvider extends AbstractAuthorizationProvider {
	constructor(loginScriptTimeout = 3500) {
		super();

		this.isLoaded = isLoaded();
		this.isReady = this.isLoaded;

		const instance = this;

		let loginScriptTimeoutId = null;

		if (!this.isLoaded) {
			loginScriptTimeoutId = setTimeout(() => {
				clearTimeout(loginScriptTimeoutId);

				this.isReady = true;
				if (this.onReady) {
					this.onReady();
				}
			}, loginScriptTimeout);
		}

		function isLoaded() {
			return !!(
				window.login &&
				window.login.current &&
				typeof window.login.current.state === 'string'
			);
		}

		function onStateChange() {
			if (typeof loginScriptTimeoutId === 'number') {
				clearTimeout(loginScriptTimeoutId);
			}

			if (!instance.isLoaded && isLoaded()) {
				instance.isLoaded = true;
			}
			if (!instance.isReady) {
				instance.isReady = true;

				if (instance.onReady) {
					instance.onReady();
				}
			}
			if (typeof instance.onStateChange === 'function') {
				instance.onStateChange();
			}
		}

		function onBadge() {
			if (!instance.isLoaded && isLoaded()) {
				instance.isLoaded = true;
			}

			if (!instance.isReady) {
				instance.isReady = true;

				if (instance.onReady) {
					instance.onReady();
				}
			}
		}

		window.addEventListener(LoginEvent.LOGIN, onStateChange);
		window.addEventListener(LoginEvent.LOGOUT, onStateChange);
		window.addEventListener(LoginEvent.FORGET, onStateChange);
		window.addEventListener(LoginEvent.BADGE, onBadge);
	}

	isSignedIn() {
		const loginState = window.login && window.login.current;
		return !!(loginState && loginState.state === LoginState.SIGNED_IN);
	}

	getAuthorizationToken(callback) {
		const socialToken = window.login && window.login.socialToken;
		const version = window.login && window.login.version;

		if (
			!this.isLoaded ||
			!this.isSignedIn() ||
			!socialToken ||
			!socialToken.get ||
			!version
		) {
			setTimeout(() => callback(undefined, null), 0);
			return;
		}

		// todo delete _getSocialTokenByCallback when v2 is not supported anymore
		// v2 is old version of login script. At v3 the socialToken.get() returns a promise
		const shouldGetTokenByCallback = version.startsWith('2.');

		if (shouldGetTokenByCallback) {
			this._getSocialTokenByCallback(socialToken, callback);
		} else {
			this._getSocialTokenByPromise(socialToken, callback);
		}
	}

	_getSocialTokenByCallback(socialToken, callback) {
		socialToken.get(
			token => callback(undefined, token),
			error => {
				const normalizedError =
					error instanceof Error
						? error
						: new Error(`The login API return an error: ${error}`);
				callback(normalizedError, null);
			}
		);
	}

	_getSocialTokenByPromise(socialToken, callback) {
		socialToken
			.get()
			.then(token => callback(undefined, token))
			.catch(error => {
				const normalizedError =
					error instanceof Error
						? error
						: new Error(`The login API return an error: ${error}`);
				callback(normalizedError, null);
			});
	}
}
